import type { SVGProps } from 'react';

export function SunIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      {...props}
      aria-hidden={!(props['aria-label'] || props['aria-labelledby'])}
      focusable="false"
      role="img"
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20.485 3.515a1.09 1.09 0 0 1 0 1.542L18.942 6.6A1.09 1.09 0 0 1 17.4 5.057l1.543-1.542a1.09 1.09 0 0 1 1.542 0M12 0a1.09 1.09 0 0 1 1.09 1.09v2.183a1.09 1.09 0 1 1-2.18 0V1.09A1.09 1.09 0 0 1 12 0M5.057 3.515 6.6 5.057A1.09 1.09 0 0 1 5.057 6.6L3.515 5.057a1.09 1.09 0 0 1 1.542-1.542M3.273 10.91a1.09 1.09 0 1 1 0 2.18H1.09a1.09 1.09 0 1 1 0-2.18zM6.6 17.4a1.09 1.09 0 0 1 0 1.543l-1.543 1.542a1.091 1.091 0 1 1-1.542-1.543L5.057 17.4a1.09 1.09 0 0 1 1.543 0M12 19.636a1.09 1.09 0 0 1 1.09 1.091v2.182a1.09 1.09 0 1 1-2.18 0v-2.182a1.09 1.09 0 0 1 1.09-1.09M18.943 17.4l1.542 1.543a1.091 1.091 0 0 1-1.543 1.542L17.4 18.942a1.09 1.09 0 0 1 1.543-1.542M22.91 10.91a1.09 1.09 0 1 1 0 2.18h-2.183a1.09 1.09 0 1 1 0-2.18zM18 12a6 6 0 1 1-12 0 6 6 0 0 1 12 0" />
    </svg>
  );
}
